<template>
    <div
        v-spinner="loading"
        class="page-list"
    >
        <v-spinner :opacity="0.5">
            加载中...
        </v-spinner>
        <div class="page-list-title">
            敏感操作日志
        </div>
        <div class="page-list-head">
            <div class="page-list-head-left">
                <v-date-picker
                    v-model="duration"
                    class="date-picker"
                    :max-range="90"
                    :shortcuts="shortcuts"
                    @change="onChange"
                />
                <common-select
                    ref="commonSelectRef"
                    search="搜索"
                    :list-function="listFun"
                    :multiple="true"
                    :maps="{ value: 'id', text: 'name' }"
                    search-placeholder="员工姓名/账号名"
                    :value="getSelectOperator"
                    :select-required="true"
                    save-selected-switch
                    placement="bottom-start"
                    :inline="true"
                    trigger-kind="box"
                    :max-level="1"
                    class="common-select"
                    @confirm="selectConfirm"
                >
                    <template slot="trigger">
                        <div class="common-select-trigger">
                            <v-select
                                :options="[]"
                                :inline="true"
                                class="select-box"
                            >
                                <template slot="placeholder">
                                    <!-- TODO：这里要显示筛选的具体操作人 -->
                                    <!-- 为空或者是全选时显示 -->
                                    <template
                                        v-if="nameArr.length === 0 || nameArr.length === logData.operators.length"
                                    >
                                        全部操作人
                                    </template>
                                    <template v-else-if="nameArr.length === 1">
                                        {{ nameArr[0] }}
                                    </template>
                                    <template v-else>
                                        <span
                                            class="select-box-overfolw"
                                        >{{ nameArr.toString() }}</span>{{ '等' + nameArr.length + '人' }}
                                    </template>
                                </template>
                            </v-select>
                        </div>
                    </template>
                </common-select>
            </div>

            <v-tip
                ref="exportQa"
                placement="top"
                :gap="10"
            >
                <span>将导出所选时间范围内所有敏感操作日志</span>
            </v-tip>
            <div
                v-tip:exportQa.hover
                class="page-list-head-right"
            >
                <v-button
                    icon="basic_share_line"
                    remote
                    @click="handleExport"
                />
                <!-- <v-icon name="export" /> -->
                <!-- <span
                    class="page-list-head-right-text"
                    @click="handleExport"
                >导出</span> -->
            </div>
        </div>

        <div
            v-if="logData.logs"
            class="page-list-content"
        >
            <div class="page-list-content-list">
                <!-- <tree-item
                    v-for="item in logData.modules"
                    :key="item.name"
                    :page-data="item"
                    :bo="bo"
                    @getSeletedBo="getBo"
                /> -->
                <folder-tree
                    :tree="logData.modules"
                    :current="bo"
                    @click="getBo"
                ></folder-tree>
            </div>

            <div class="page-list-content-table">
                <v-table
                    :data="logData.logs"
                    :selectable="selectable"
                >
                    <v-table-column
                        v-for="column in columns1"
                        :key="column.label"
                        :column-key="column.columnKey"
                        :label="column.label"
                        :width="column.width"
                    />
                    <v-table-column
                        column-key="operation_type"
                        label="操作类型"
                        :width="176"
                        :render-header="renderHeader"
                    >
                        <template slot="header">
                            <div class="operation_type">
                                操作类型
                                <v-icon
                                    v-popconfirm:operationType
                                    name="ic_filter_normal"
                                />
                            </div>
                        </template>
                    </v-table-column>
                    <v-table-column
                        column-key="detail"
                        label="操作详情"
                    >
                        <template
                            slot="cell"
                            slot-scope="props"
                        >
                            <div
                                v-for="(item, index) in props.row.detail"
                                :key="index"
                                class="detail"
                            >
                                <div
                                    v-for="(self, keys) in item.content"
                                    :key="keys"
                                    class="detail-content"
                                >
                                    <template v-if="self.type === 0">
                                        <span
                                            class="detail-content-text"
                                            :class="self.style ? 'gray' : ''"
                                        >
                                            {{ self.content }}
                                        </span>
                                    </template>
                                    <template v-if="self.type === 1">
                                        <!-- <div class="detail-content-text-todetail"> -->
                                        <a
                                            href="javascript:;"
                                            class="detail-content-tag-a"
                                            @click.stop="openPanel(self.content)"
                                        >
                                            查看详情
                                        </a>
                                        <!-- </div> -->
                                    </template>
                                    <template v-if="self.type === 2">
                                        <img
                                            :src="self.content"
                                            class="detail-content-image"
                                        >
                                    </template>
                                </div>
                            </div>
                        </template>
                    </v-table-column>
                </v-table>
                <v-pagination
                    class="pagination"
                    :index="pagination.page"
                    :count="pagination.size"
                    :total="pagination.total"
                    show-quick
                    @change="pageChange"
                />
            </div>
        </div>

        <v-popconfirm
            ref="operationType"
            :inline="true"
            @confirm="handleConfirm"
        >
            <div class="demo-popconfirm-first">
                <div>
                    <v-checkbox
                        v-model="isAllCheck"
                        :indeterminate="indeterminate"
                        label="全部操作类型"
                        @change="handleChange"
                    />
                </div>
                <v-checkbox-group
                    v-model="modelArray"
                    @change="handleGroupChange"
                >
                    <div
                        v-for="item in getcheckboxData"
                        :key="item.id"
                        class="checkbox-item"
                    >
                        <v-checkbox :value="item.id">
                            {{ item.name }}
                        </v-checkbox>
                    </div>
                </v-checkbox-group>
            </div>
            <span slot="confirm-text">筛选</span>
        </v-popconfirm>

        <template v-if="panelData.content">
            <v-panel
                v-model="detailPanel"
                class="page-list-panel"
                :width="860"
                placement="right"
            >
                <panel-content :page-data="panelData" />
            </v-panel>
        </template>
    </div>
</template>

<script>
/*eslint-disable */
import get from 'lodash/get';
// import CommonSelect from 'src/components/common-select';
import { Icon } from 'vhtml-ui';
import XLSX from 'xlsx';
import TreeItem from '../components/tree-item/index';
import PanelContent from '../components/panel-content';
import dateTool from '../utils/dateTool';
import FolderTree from '../components/folder-tree'

// eslint-disable-next-line no-useless-escape
const req = require.context('../assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);
/**
 * 1. 全部操作人筛选 vhtml-market common-select 组件需要兼容
 * 2. 顶部【导出】高度不一致，对齐问题。
 * 3. 筛选按钮大小不一样，hover的border不一样
 * 4. 操作类型筛选pop宽度不一致
 * 5. 分页页码颜色不一致
 * 6. 左侧选择背景颜色不一致
 * 7. 筛选和表格的间距
 */
const SHORTCUTS = [
    {
        text: '今天',
        value: [0, 0]
    },
    {
        text: '昨天',
        value: [-1, -1]
    },
    {
        text: '最近7天',
        value: [-7, -1]
    },
    {
        text: '最近30天',
        value: [-30, -1]
    }
];

export default {
    components: {
        TreeItem,
        PanelContent,
        FolderTree,
        // CommonSelect
    },
    data() {
        return {
            loading: false,
            shortcuts: SHORTCUTS,
            duration: [0, 0],
            date: {
                starttime: 0,
                endtime: 0
            },
            default2: [],
            exportParams: {
                keyword: '',
                FStatus: -1,
                FlevelId: -1,
                sort: 'modifytime',
                order: 'DESC',
                selectedIds: []
            },
            exportTotal: 1000,
            validator: exportTotal => {
                return exportTotal <= 100000;
            },
            exportUrl: '/er/export',
            logData: {},
            columns1: [
                {
                    label: '操作时间',
                    columnKey: 'operation_time',
                    width: 223
                    // align: 'center',
                },
                {
                    label: '操作人',
                    columnKey: 'operator_name',
                    width: 272,
                    sortable: true,
                }
            ],
            pagination: {
                page: 1,
                size: 15,
                total:0,
                showQuick:true
            },
            selectOptions: [{ text: '全部操作类型', value: '' }],
            operation_type: '',
            isAllCheck: false,
            indeterminate: false,
            modelArray: [],
            detailPanel: false,
            bo: 50,
            operator: [],
            getSelectOperator: [],
            total:0,
            panelData:"",
            nameArr:[],
            searchArr:[]
        };
    },
    computed: {
        // 操作人默认全选
        // getSelectOperator() {
        //     return get(this.logData, 'operators', []).map((val, index) => {
        //         return index;
        //     });
        // },
        // getOperationType() {
        //     const arr = get(this.logData, 'operations', []).map(val => {
        //         const obj = {};
        //         obj.text = val.name;
        //         obj.value = val.id;
        //         return obj;
        //     });
        //     console.log(arr, 'arr');

        //     return _.concat(this.selectOptions, arr);
        // },
        getcheckboxData() {
            return get(this.logData, 'operations');
        }
    },

    created() {
        this.getList();
    },

    methods: {
        renderHeader(h) {
            return h("div", {
                "class": "operation_type"
            }, [
                "操作类型",
                h("v-icon", {
                    "directives": [{
                        "name": "popconfirm",
                        "value": "operationType"
                    }],
                    "props": {
                        "name": "ic_filter_normal"
                    }
                })
            ])
        },
        downloadExcel(filename, data) {
            const wsName = 'SheetJS';
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.aoa_to_sheet(data);
            // 将文档插入文件并定义名称
            XLSX.utils.book_append_sheet(wb, ws, wsName);
            // 执行下载
            XLSX.writeFile(wb, filename);
        },
        transformData(data) {
            const result = [];
            data.forEach(item => {
                result.push(item.item);
            });
            return result;
        },
        handleExport() {
            const params = {
                ...this.date
            };
            this.loading = true;
            this.$ajax
                .gatewayPost(`/v1/audit/opLog/Export`, params)
                .then(res => {
                    const { code, data } = res || {};
                    if (code === 0) {
                        this.downloadExcel(data.name, this.transformData(data.data));
                    } else {
                        this.$message.error('导出数据出错');
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onChange() {
            const startDate = dateTool.format('Y-m-d', new Date(this.duration[0]).getTime());
            const endDate = dateTool.format('Y-m-d', new Date(this.duration[1]).getTime());
            this.date.starttime = new Date(startDate).getTime() - 8 * 3600000;
            this.date.endtime = new Date(endDate).getTime() - 8 * 3600000;
            // 切换时间的时候 清空筛选条件
            this.modelArray = [];
            this.operator = [];
            this.nameArr = [];
            this.getList();
        },
        getList() {
            // console.log(this.indeterminate,"this.indeterminate");
            const params = {
                ...this.date,
                page:this.pagination.page,
                size:this.pagination.size,
                bo: this.bo,
                operation: this.modelArray.length === get(this.logData, 'operations', []).length ? [] : this.modelArray,
                operator: this.operator
                // order_field: '',
                // order_type: ''
            };
            this.loading = true;
            this.$ajax
                .gatewayPost(`/v1/audit/opLog/Log`, params)
                .then(res => {
                    const { code, data } = res || {};
                    // sueccess
                    if (code === 0) {
                        this.logData = data;
                        this.$nextTick(() => {
                            // 点击筛选以后需要先将接口清空
                            this.getSelectOperator = [];
                            // 需要过滤接口返回的 operator 为空的话为全选 不为空的话 只选中operator返回的当前
                            if(get(data,'operator').length) {
                                get(data,'operator',[]).map(val=>{
                                    get(data, 'operators', []).map((item,index)=>{
                                        if(item.id === val) {
                                            this.getSelectOperator.push(index);
                                        }
                                    })
                                })
                            } else {
                                this.getSelectOperator = get(data, 'operators', []).map((val, index) => {
                                    return index;
                                });
                            }
                        });
                        get(data,"modules",[]).map(val=>{
                            val.bos.map(item=>{
                                if(item.id === this.bo) {
                                    this.pagination.total = item.count
                                }
                            })
                        })
                        this.$refs.commonSelectRef && this.$refs.commonSelectRef.refresh();
                    } else {
                        this.$message.error('获取数据出错');
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getBo(data) {
            const { id: value } = data;
            console.log(this.bo, value)
            if (this.bo === value) return;
            // this.pagination.total = current.count;
            this.bo = value;
            this.modelArray = [];
            this.operator = [];
            this.nameArr = [];
            this.getList();
        },
        selectable(data) {
            // console.log(data, 'selectable');
        },
        handleConfirm(data) {
            this.getList();
        },
        // 操作类型全选
        handleChange(value) {
            // console.log(value,"operationsoperationsoperations");

            this.modelArray = value
                ? get(this.logData, 'operations', []).map(val => {
                    // console.log(val);
                    return val.id;
                })
                : [];
        },
        // 操作类型筛选列表点击事件
        handleGroupChange() {
            this.indeterminate = this.modelArray.length < get(this.logData, 'operations', []).length;
            this.isAllCheck = this.modelArray.length > 0;
            // console.log(this.indeterminate, this.isAllCheck, 'this.isAllCheck', this.modelArray);
        },
        selectConfirm({ selected }) {
            // 可能是搜索的出来的人
            let selectedArr = this.searchArr.length?this.searchArr :selected ;
            this.nameArr = [];
            // console.log(3434, selectedArr,selected);
            const arr = [];
            selectedArr.map(val => {
                arr.push(get(this.logData, 'operators')[val].id);
                this.nameArr.push(get(this.logData, 'operators')[val].name)
            });
            // console.log(this.nameArr,"nameArr");
            this.operator = Array.from(new Set(arr));
            this.getList();
        },
        listFun(index, count, searchValue) {
            this.searchArr = [];
            /* eslint-disable */
            let newArr = [];
            // 一个工号改名前操作了一条记录，改名后又操作一条。此时后台会返回id相同的两个名字
            const arr = get(this.logData,"operators",[]).map((val,index) => {
                return {
                    id:index,
                    name:val.name
                }
            })
            // 搜索操作人
            if(searchValue) {
                arr.filter(item => {
                    if (item.name.indexOf(searchValue) !== -1) {
                        newArr.push(item);
                    }
                });
                this.searchArr = newArr;
                this.searchArr = this.searchArr.map(item=>{
                    return item.id
                })
                // console.log(this.searchArr,"searchArr");
            } else {
                newArr = arr;
            }
            return new Promise(resolve => {
                resolve(newArr);
            })
        },
        pageChange(page, size) {
            // console.log(page, size);
            this.pagination.page = page;
            this.pagination.size = size;
            this.getList();
        },
        openPanel(data) {
            // console.log(data);
            this.panelData =JSON.parse(data);
            this.detailPanel = true;
        }
    }
};
</script>
<style lang="less" >
@import './style.less';
</style>
